<template>
  <div></div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  data() {
    return {}
  },
  computed: {
    ...mapGetters('practice', ['TASK_DATA']),
  },
  async created() {
    console.log('%c 进入开票项目地址： ==>', 'color:green', 'http://localhost:8000' + this.$route.path)
    await this.getBusinessList()
    if (this.TASK_DATA[0].isFinish === '2') {
      this.$router.push({
        path: '/index',
      })
    } else {
      this.$router.push({
        path: '/login',
      })
    }
  },
  methods: {
    ...mapActions('practice', ['getBusinessList']),
  },
}
</script>

<style>
</style>
